// SEM-7207 — /settings/holidays API istemcisi.
//
// Takvim iki katmandır ve uç ikisini TEK listede döndürür: platform satırları
// (`tenant_id` null, `is_system`) her kiracının okuduğu kanuni takvimdir ve
// silinemez; kiracı satırları o kiracıya aittir. Ekran ayrımı `is_system`
// üzerinden çizer.

import { platformGraph } from "@/api/platform-graph";
import { unwrapEnvelope, type EnvelopedFetchResult } from "@/api/errors";

export type HolidayKind = "public" | "half_day" | "religious" | "tenant";

export interface HolidayRow {
  readonly holiday_id: string;
  readonly tenant_id: string | null;
  readonly date: string;
  readonly name: string;
  readonly kind: string;
  readonly is_system: boolean;
  readonly year: number | null;
  readonly created_at: string | null;
  readonly updated_at: string | null;
}

export interface HolidayCalendar {
  readonly items: readonly HolidayRow[];
  /** Seçicinin yılları — satırı OLAN yıllar, takvim aralığı değil. */
  readonly years: readonly number[];
  /** Sunucunun gerçekten döndürdüğü yıl; istenmediğinde satırı olan son yıl. */
  readonly year: number;
}

export interface HolidayInput {
  readonly date: string;
  readonly name: string;
  readonly kind?: HolidayKind;
}

type HolidaysGet = (
  path: "/v1/holidays",
  init?: { params?: { query?: { year?: number } } },
) => Promise<EnvelopedFetchResult<{ items: HolidayRow[]; years: number[]; year: number }>>;

export async function fetchHolidays(year?: number): Promise<HolidayCalendar> {
  const get = platformGraph.GET as unknown as HolidaysGet;
  const query: { year?: number } = {};
  if (year !== undefined) query.year = year;
  return unwrapEnvelope(get("/v1/holidays", { params: { query } }));
}

type HolidayPost = (
  path: "/v1/holidays",
  init: { body: HolidayInput },
) => Promise<EnvelopedFetchResult<{ holiday: HolidayRow }>>;

export async function createHoliday(input: HolidayInput): Promise<HolidayRow> {
  const post = platformGraph.POST as unknown as HolidayPost;
  const result = await unwrapEnvelope(post("/v1/holidays", { body: input }));
  return result.holiday;
}

type HolidayImportPost = (
  path: "/v1/holidays/import",
  init: { body: { items: readonly HolidayInput[] } },
) => Promise<EnvelopedFetchResult<{ imported: number; items: HolidayRow[] }>>;

export async function importHolidays(items: readonly HolidayInput[]): Promise<number> {
  const post = platformGraph.POST as unknown as HolidayImportPost;
  const result = await unwrapEnvelope(post("/v1/holidays/import", { body: { items } }));
  return result.imported;
}

type HolidayDelete = (
  path: "/v1/holidays/{id}",
  init: { params: { path: { id: string } } },
) => Promise<EnvelopedFetchResult<{ holiday: HolidayRow }>>;

/** Uç, silinen satırın son hâlini döndürür (zarf her yanıtta gövde ister). */
export async function deleteHoliday(holidayId: string): Promise<HolidayRow> {
  const del = platformGraph.DELETE as unknown as HolidayDelete;
  const result = await unwrapEnvelope(
    del("/v1/holidays/{id}", { params: { path: { id: holidayId } } }),
  );
  return result.holiday;
}
